import React, { Suspense } from 'react';
import { ThemeProvider, Pendo } from '@social-solutions/component-library';
import './App.css';
import './fonts/jxi2cmo.css';
import Loader from 'components/Generics/Loader/Loader';
import Routes from './Routes';
import ErrorBoundary from './ErrorBoundary';
import { IntegrationContext } from 'helpers/integration/IntegrationContext';
import { FeatureFlagBoundary } from 'FeatureFlagBoundary';
import { integrationProps } from 'helpers/integration/integrationProps';
import { AnalyticsServiceFactory } from 'services';

const App: React.FC = () => {
    return (
        <>
            <IntegrationContext.Provider value={integrationProps}>
                <ThemeProvider>
                    <ErrorBoundary>
                        <FeatureFlagBoundary>
                            <Suspense fallback={<Loader />}>
                                <Routes />
                            </Suspense>
                        </FeatureFlagBoundary>
                    </ErrorBoundary>
                </ThemeProvider>
            </IntegrationContext.Provider>
            {(AnalyticsServiceFactory.get().ssoShouldInitializeAnalytics() &&
                <Pendo user={AnalyticsServiceFactory.get().getUser()} orgId={integrationProps.getTenantId()} />)}
        </>
    );
};

export default App;

